import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import { useQuery } from '@tanstack/react-query';
import { getHeadersWithUniqueVisitorId } from '../../Auth/index.js';

const fetchConversationStarters = (stacklineSku, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
axios, apiBaseUrl) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (axios) {
        // Landing-page path: use axios instance
        const response = yield axios.post('/concierge/conversationStarters', {
            stacklineSku,
        });
        return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.questions) || [];
    }
    else if (apiBaseUrl) {
        // Checkout-shop-app path: use fetch with apiBaseUrl
        const response = yield fetch(`${apiBaseUrl}/concierge/conversationStarters`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ stacklineSku }),
        });
        if (response.ok) {
            const data = yield response.json();
            return (data === null || data === void 0 ? void 0 : data.questions) || [];
        }
        return [];
    }
    else {
        // Default path: use fetch with relative URL and auth headers
        const headers = yield getHeadersWithUniqueVisitorId();
        const response = yield fetch(`/api-rewards/concierge/conversationStarters`, {
            method: 'POST',
            headers: Object.assign(Object.assign({}, headers), { 'Content-Type': 'application/json' }),
            body: JSON.stringify({ stacklineSku }),
        });
        if (response.ok) {
            const data = yield response.json();
            return (data === null || data === void 0 ? void 0 : data.questions) || [];
        }
        return [];
    }
});
/**
 * Hook to fetch product-specific conversation starters
 *
 * @example
 * // In landing-page (with axios)
 * const { questions, isLoading } = useConversationStarters({
 *   stacklineSku: 'ABC123',
 *   axios: axiosInstance,
 * });
 *
 * @example
 * // In checkout-shop-app (with apiBaseUrl)
 * const { questions, isLoading } = useConversationStarters({
 *   stacklineSku: 'ABC123',
 *   apiBaseUrl: 'https://api.brandclub.com/api-rewards',
 * });
 *
 * @example
 * // With default fetch (relative URL)
 * const { questions, isLoading } = useConversationStarters({
 *   stacklineSku: 'ABC123',
 * });
 */
const useConversationStarters = ({ stacklineSku, axios, apiBaseUrl, enabled = true, }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['conversationStarters', stacklineSku, apiBaseUrl],
        queryFn: () => fetchConversationStarters(stacklineSku, axios, apiBaseUrl),
        enabled: enabled && !!stacklineSku,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    });
    return {
        questions: data || [],
        isLoading,
        error: error,
    };
};

export { useConversationStarters };
//# sourceMappingURL=useConversationStarters.js.map
